export default __webpack_public_path__ + "static/character-dedae11a4bf0080749f3c416f31d1b12.png";